import { Box, ListItem, ListItemText, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { LegendBoxContentsName, LegendBoxList, LegendCssSquareIconListItem, LegendListDivider } from "../../legend/LegendBoxComponents";
import { memo } from "react";

const useStyles = makeStyles({
  listItem: {
    padding: 0,
    height: 17
  },
  listItemText: {
    paddingLeft: 7,
    margin: 0,
    position: "relative",
    top: 9,
    textAlign: "right",
    left: 3
  }
});

function LegendFlightHistory() {
  const {t} = useTranslation();
  const classes = useStyles();
  return (
    <>
      <Box sx={{minWidth: 115}}>
        <LegendBoxContentsName>{t("Altitude")} (ft)</LegendBoxContentsName>
      </Box>
      <Box sx={{display: "flex"}}>
        <LegendBoxList width={59}>
          <ListItem className={classes.listItem}>
            <ListItemText className={classes.listItemText}>
              53000
            </ListItemText>
          </ListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(106,27,154, 0.8)'} text={<>5000</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(0, 0, 128, 0.8)'} text={<>3000</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(21, 101, 192, 0.8)'} text={<>2000</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(0, 131, 143, 0.8)'} text={<>1000</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(0, 128, 0, 0.8)'} text={<>700</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(158, 157, 36, 0.8)'} text={<>500</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(249, 168, 37, 0.8)'} text={<>300</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(239, 108, 0, 0.8)'} text={<>200</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(198, 40, 40, 0.8)'} text={<>100</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(128, 0, 0, 0.8)'} text={<></>}></LegendCssSquareIconListItem>
        </LegendBoxList>
      </Box>
    </>
  )
}

export default memo(LegendFlightHistory);
